import React, { useEffect, useRef, useState } from "react";
import styles from "../../assets/css/signupv2.module.css";
import logo from "../../assets/img/signupv2/toi/logo.svg";
import logoSmall from "../../assets/img/signupv2/toi/logo_abound_toi.svg";
import freeTag from "../../assets/img/signupv2/toi/free.svg";
import cardIcon from "../../assets/img/signupv2/toi/card.svg";
import exclusiveReward from "../../assets/img/signupv2/toi/exclusive-rewards.svg";
import automaticCashback from "../../assets/img/signupv2/toi/automatic-cashback.svg";
import AccountFooter from "../../components/AccountFooter";
import footerLogo from "../../assets/img/signupv2/toi/footerLogo.png";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  getAuth,
  setUserType,
  userSignup,
  validateEmail,
} from "../../redux/slices/authSlice";
import {
  CompleteRegistration,
  getUtmCampaign,
  getUtmMedium,
  getUtmSource,
  Add_To_Wishlist,
  Web_Signup_completed,
  Web_Signup_landed,
} from "../../libs/events";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getRecaptcha } from "../../redux/slices/recaptchaSlice";
import AddCard from "../../components/AddCard";
import { getUserToken } from "../../libs/user";

function TOISignup() {
  const [searchParams] = useSearchParams();
  const bankType = searchParams.get("banktype");

  const bankTypeList = ["rakuten"];

  const [isSubmitSignup, setSubmitSignup] = useState(false);
  const [mount, setMount] = useState(false);
  const [emailReadOnly, setEmailReadOnly] = useState(false);
  const [bankAddOption, setBankAddOption] = useState(null);
  const [addCard, setAddCard] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(false);

  const interval0 = useRef();
  const authToken = getUserToken();

  const auth = useSelector((state) => state.auth);
  const fingerprint = useSelector((state) => state.fingerprint);
  const recaptcha = useSelector((state) => state.recaptcha);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const signup = (data) => {
    if (validateSignupForm()) {
      setSubmitSignup(true);
      dispatch(validateEmail(data.email))
        .unwrap()
        .then((response) => {
          dispatch(
            userSignup({
              firstName: "",
              lastName: "",
              email: data.email,
              password: data.password,
              refCode: "",
              reCaptcha: recaptcha.data,
              deviceId: fingerprint.data,
              isEmailSignup: true,
            })
          )
            .unwrap()
            .then((response) => {
              Web_Signup_completed({
                signup_source: "web",
                email: response.user.email,
                utm_source:getUtmSource()
              });
              const { user_origin_country } = response.user;
              if (user_origin_country === "INDIAN") {
                Add_To_Wishlist({
                  email: response.user.email,
                });
                dispatch(setUserType(user_origin_country));
              }
              CompleteRegistration();
              // dispatch(getAuth());
              setSubmitSignup(false);
              if (bankType === "rakuten") {
                setAddCard(true);
              }
            })
            .catch((error) => {
              setSubmitSignup(false);
              // dispatch(getRecaptcha({ action: "signup" }));
            });
        })
        .catch((error) => {
          setSubmitSignup(false);
          console.log(error);
        });
    }
  };

  const validateSignupForm = () => {
    try {
      if (auth.validateEmail.error) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      return false;
    }
  };

  // useEffect(() => {
  //   dispatch(getRecaptcha({ action: "signup" }));
  // }, [dispatch]);

  useEffect(() => {
    setMount(true);
    if (mount === true) {
      // const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
      // reset({ email: userData.username });

      interval0.current = setInterval(() => {
        if (watch("email") === "") {
          const userData = JSON.parse(
            sessionStorage.getItem("userData") || "{}"
          );
          if (userData.username) {
            Web_Signup_landed({
              utm_source: getUtmSource(),
              utm_medium: getUtmMedium(),
              utm_campaign: getUtmCampaign(),
              user_source: null,
              email: userData.username,
            });
            reset({ email: userData.username });
            setEmailReadOnly(true);
          }
        } else {
          clearInterval(interval0.current);
        }
      }, 500);
    }

    return () => {
      clearInterval(interval0.current);
    };
  }, [mount]);

  useEffect(() => {
    if (authToken && bankType) {
      if (bankType === "rakuten") {
        setAddCard(true);
      }
    }
  }, [authToken, bankType]);

  return (
    <>
      {!addCard && (
        <>
          <div className={styles.container}>
            {/* <div className={styles.preHeader}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className={`w-6 h-6 ${styles.preHeaderClose}`}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div> */}
            <div className={styles.header}>
              <img src={logo} />
            </div>
            <div className={styles.bodyText1}>
              <div className={styles.bodyText1text1}>Sign up for Abound.</div>
              <div className={styles.bodyText1text2}>
                Get 1 year subscription of TOI+ free.
              </div>
            </div>
            <div className={styles.bodyText2}>
              No hidden charges. You pay nothing. Abound is free too.
            </div>
            <div className={styles.signupBox}>
              <form id="formmm" onSubmit={handleSubmit(signup)}>
                <div className={styles.signupBadge}>
                  <img src={logoSmall} />
                  <img className={styles.mr1} src={freeTag} />
                </div>
                <div className={styles.inputControl}>
                  <input
                    readOnly={emailReadOnly}
                    {...register("email", {
                      required: true,
                      pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                    })}
                    onBlur={(e) => {
                      if (!errors.email) {
                        dispatch(validateEmail(e.target.value));
                      }
                    }}
                    className={styles.input}
                    placeholder="Email Address"
                  />
                  {auth.validateEmail.error && !errors.email && (
                    <span className={styles.errorMsg}>
                      {auth.validateEmail.error?.message}
                    </span>
                  )}
                  {errors.email?.type === "required" && (
                    <span className={styles.errorMsg}>
                      This field is required
                    </span>
                  )}
                  {errors.email?.type === "pattern" && (
                    <span className={styles.errorMsg}>
                      Invalid email format
                    </span>
                  )}
                </div>

                <div className={styles.inputControl}>
                  <input
                    type="password"
                    {...register("password", {
                      required: true,
                      minLength: 8,
                    })}
                    className={styles.input}
                    placeholder="Create Password"
                  />
                  {errors.password?.type === "required" && (
                    <span className={styles.errorMsg}>
                      This field is required
                    </span>
                  )}
                  {errors.password?.type === "minLength" && (
                    <span className={styles.errorMsg}>
                      The password must contain at least 8 characters
                    </span>
                  )}
                  {auth.userSignup.error && !errors.password && (
                    <span className={styles.errorMsg}>
                      {auth.userSignup.error?.message}
                    </span>
                  )}
                </div>

                <div className={styles.signupBoxText1Container}>
                  <div className={styles.signupBoxText1ContainerIcon1}>
                    <img src={cardIcon} />
                  </div>
                  <div className={styles.signupBoxText1ContainerText1}>
                    You'll be asked to enter your credit card number in the next
                    step to find cash back on your transactions. You will not be
                    asked to enter CVV or expiry date of your card. This is
                    completely secure and you'll never be charged.
                  </div>
                </div>
                <div className={styles.signupBoxText2}>
                  By clicking Continue below, I agree to the{" "}
                  <a href="/consent" target="_blank" className="link_underLine">
                    Abound Consent
                  </a>
                  , and{" "}
                  <a
                    href="/terms-conditions"
                    target="_blank"
                    className="link_underLine"
                  >
                    Terms and Conditions
                  </a>
                  , and acknowledge the receipt of the{" "}
                  <a href="/privacy" target="_blank" className="link_underLine">
                    Privacy Policy
                  </a>
                  .
                </div>
                <button className={styles.signupButton}>Continue</button>
              </form>
              <div className={styles.loginOption}>
                <Link to="/login">Already have an account? Login</Link>
              </div>
            </div>
            <div
              className={styles.mtextBox}
              onClick={() => setToggleMenu(!toggleMenu)}
            >
              <div className={styles.mtextBoxTitle}>
                Learn more about Abound
              </div>
              <div
                className={`${styles.mtextBoxTitleIcon} ${
                  toggleMenu ? styles.mtextBoxTitleIconActive : ""
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              {/* <div className={styles.mtextBoxDesc}>
                Join Abound for free to get exclusive perks, offers, cash
                back and much more.
              </div> */}
            </div>
            <div className={`${styles.expendMenu}`}>
              {toggleMenu && (
                <>
                  <div className={styles.textBox}>
                    <div className={styles.textBoxTitle}>Exclusive Rewards</div>
                    <div className={styles.textBoxDesc}>
                      Exceptional rewards, offers, and cash back curated for
                      you.
                    </div>
                    <div className={styles.textBoxImage}>
                      <img src={exclusiveReward} />
                    </div>
                  </div>
                  <div className={styles.textBox}>
                    <div className={styles.textBoxTitle}>
                      Automatic Cash Back
                    </div>
                    <div className={styles.textBoxDesc}>
                      Just connect your bank and earn cash back from brands you
                      love.
                    </div>
                    <div className={styles.textBoxImage}>
                      <img src={automaticCashback} />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className={styles.footerLogo}>
              <img src={footerLogo} />
            </div>
          </div>
          <AccountFooter />
        </>
      )}

      {addCard && <AddCard open={setAddCard} addCard={addCard} />}
    </>
  );
}

export default TOISignup;
